export const API_URL: string = import.meta.env.VITE_API || "";

export const BASE_URL = import.meta.env.VITE_BASE_URL !== undefined
  ? import.meta.env.VITE_BASE_URL
  : "https://brandcentral.verizonwireless.com.qa.epqa.us";

export const COGNITO_REGION = import.meta.env.VITE_COGNITO_REGION !== undefined
  ? import.meta.env.VITE_COGNITO_REGION
  : "";
export const COGNITO_USER_POOL_ID = import.meta.env.VITE_COGNITO_USER_POOL_ID !== undefined
  ? import.meta.env.VITE_COGNITO_USER_POOL_ID
  : "";

export const COGNITO_USER_POOL_CLIENT_ID = import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID !== undefined
  ? import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID
  : "";

export const COGNITO_AUTH_FLOW_TYPE = import.meta.env.VITE_COGNITO_AUTH_FLOW_TYPE !== undefined
  ? import.meta.env.VITE_COGNITO_AUTH_FLOW_TYPE
  : "";

export const COGNITO_OAUTH_DOMAIN = import.meta.env.VITE_COGNITO_OAUTH_DOMAIN !== undefined
  ? import.meta.env.VITE_COGNITO_OAUTH_DOMAIN
  : "";

export const COGNITO_OAUTH_SCOPE = import.meta.env.VITE_COGNITO_OAUTH_SCOPE !== undefined
  ? import.meta.env.VITE_COGNITO_OAUTH_SCOPE!.split(",")
  : [];

export const COGNITO_OAUTH_REDIRECT_SIGN_IN = import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGN_IN !== undefined
  ? import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGN_IN
  : "";

export const COGNITO_OAUTH_REDIRECT_SIGN_OUT = import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGN_OUT !== undefined
  ? import.meta.env.VITE_COGNITO_OAUTH_REDIRECT_SIGN_OUT
  : "";

export const COGNITO_OAUTH_RESPONSE_TYPE = import.meta.env.VITE_COGNITO_OAUTH_RESPONSE_TYPE !== undefined
  ? import.meta.env.VITE_COGNITO_OAUTH_RESPONSE_TYPE
  : "";

export const SSO_HOST_UX_URL_REDIRECT = import.meta.env.VITE_SSO_HOST_UX_URL_REDIRECT !== undefined
  ? import.meta.env.VITE_SSO_HOST_UX_URL_REDIRECT
  : "";

export const VITE_BRAND_POLICY_TOKEN = import.meta.env.VITE_BRAND_POLICY_TOKEN !== undefined
  ? import.meta.env.VITE_BRAND_POLICY_TOKEN
  : "";

export const RECAPTCHA_API_KEY = import.meta.env.VITE_RECAPTCHA_API_KEY || "";


export const GUIDELINES_CONTENTFUL_DELIVERY_API_KEY = import.meta.env.VITE_GUIDELINES_CONTENTFUL_DELIVERY_API_KEY || "";

export const GUIDELINES_CONTENTFUL_SPACEID = import.meta.env.VITE_GUIDELINES_CONTENTFUL_SPACEID || "";

export const GUIDELINES_CONTENTFUL_ENVIRONMENT = import.meta.env.VITE_GUIDELINES_CONTENTFUL_ENVIRONMENT || "";
